import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export const FeaturesCTA = () => {
  const { elementRef, isVisible } = useScrollAnimation({ threshold: 0.3 });

  return (
    <div 
      ref={elementRef}
      className={`mt-16 bg-gradient-to-br from-deep-teal/10 to-copper/10 rounded-2xl p-8 md:p-12 border-2 border-deep-teal/20 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="text-center max-w-3xl mx-auto">
        <h3 className="font-playfair text-2xl md:text-3xl font-bold text-slate mb-4">
          Ready to see how much time your kitchen could save?
        </h3>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-6">
          <Button 
            asChild 
            size="lg" 
            className="bg-deep-teal hover:bg-deep-teal/90 text-ivory font-semibold"
          >
            <Link to="/contact">Request a Camp Demo</Link>
          </Button>
          
          <Button 
            asChild 
            size="lg" 
            variant="outline"
            className="border-2 border-deep-teal text-deep-teal hover:bg-deep-teal/5"
          >
            <a href="/#features">Watch Overview</a>
          </Button>
        </div>
      </div>
    </div>
  );
};
